<div class="modal-header py-2 bg-dark text-light">
  <h4 class="modal-title">
    배차정보
  </h4>
</div>

<div class="modal-body">
    <form [formGroup]="formGroup" (ngSubmit)="onSubmit()">
        <input type="hidden" formControlName="userCarRunId" readonly />
        <div class="form-group row align-items-center">
            <label class="col-md-3 mb-0">
                차량
            </label>
            <div class="col-md-9 position-relative">
                <div class="input-group input-group-sm">
                    <input type="text" class="form-control form-control-sm w-auto" placeholder="차량선택"
                           formControlName="dtgCarNo"
                           [ngClass]="{'is-invalid':(submitted && f.dtgUnitId.errors && f.dtgCarNo.errors)}"
                           readonly>
                    <div class="input-group-append"
                         (click)="clickOpenModalCarList(DtgActionType.read)">
                        <button type="button" class="btn btn-outline-secondary">
                            <i class="fas fa-search"></i>
                            <span class="ml-1">
                                차량검색
                            </span>
                        </button>
                    </div>
                    <div class="invalid-tooltip" *ngIf="(submitted && f.dtgUnitId.errors && f.dtgCarNo.errors)">
                        <div *ngIf="(f.dtgUnitId.errors && f.dtgCarNo.errors.required)">필수 입력 항목 입니다</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="form-group row align-items-center">
            <label class="col-md-3 mb-0">
              운전자
            </label>

            <div class="col-md-9 position-relative">
                <div class="input-group input-group-sm">
                    <input type="text" class="form-control form-control-sm w-auto" placeholder="운전자선택"
                           formControlName="userNm"
                           [ngClass]="{'is-invalid':(submitted && f.userId.errors && f.userNm.errors)}"
                           readonly>
                    <div class="input-group-append">
                        <button type="button" class="btn btn-outline-secondary"
                                (click)="clickOpenModalUserList(DtgActionType.read)">
                            <i class="fas fa-search"></i>
                            <span class="ml-1">
                                운전자 검색
                            </span>
                        </button>
                    </div>
                    <div class="invalid-tooltip" *ngIf="(submitted && f.userId.errors && f.userNm.errors)">
                        <div *ngIf="(f.userId.errors.required && f.userNm.errors.required)">필수 입력 항목 입니다</div>
                    </div>
                </div>
            </div>
        </div>
        <!--
        <input type="hidden" formControlName="dtgRegDtFrom" />
        <input type="hidden" formControlName="dtgRegDtTo" />
        -->
        <div class="form-group row align-items-center">
            <label class="col-md-3 mb-0">
                운행시작일시
            </label>
            <div class="col-md-9 position-relative">
                <input type="datetime-local" class="form-control form-control-sm w-auto"
                       formControlName="dtgRegDtFrom"
                       [ngClass]="{'is-invalid':submitted && (f.dtgRegDtFrom.errors || !checkRegDt)}">
                <div class="invalid-tooltip" *ngIf="submitted && f.dtgRegDtFrom.errors">
                    <div *ngIf="f.dtgRegDtFrom.errors.required">필수 입력 항목 입니다</div>
                </div>
                <div class="invalid-tooltip" *ngIf="submitted && !checkRegDt">
                    <div *ngIf="!checkRegDt">중복 일정 입니다.</div>
                </div>
            </div>
        </div>
        <div class="form-group row align-items-center">
            <label class="col-md-3 mb-0">
                운행종료일시
            </label>
            <div class="col-md-9 position-relative form-inline">
                <input type="datetime-local" class="form-control form-control-sm w-auto"
                       formControlName="dtgRegDtTo"
                       [ngClass]="{'is-invalid':submitted && (f.dtgRegDtTo.errors || !checkRegDt)}">
                <div class="invalid-tooltip" *ngIf="submitted && f.dtgRegDtTo.errors">
                    <div *ngIf="f.dtgRegDtTo.errors.required">필수 입력 항목 입니다</div>
                </div>
                <div class="invalid-tooltip" *ngIf="submitted && !checkRegDt">
                    <div *ngIf="!checkRegDt">중복 일정 입니다.</div>
                </div>
                <!--
                <input type="time" class="form-control form-control-sm w-auto ml-2"
                   min="00:00:00"
                   max="23:59:59"
                   formControlName="changeDtgRegDtTo"
                   (ngModelChange)="changeDtgRegTime($event, 'from')"
                   [ngClass]="{'is-invalid':submitted && (f.dtgRegDtFromTime.errors || !checkRegDt)}">
                <div class="invalid-tooltip" *ngIf="submitted && f.dtgRegDtFromTime.errors && f.dtgRegDtFromTime.errors.required">
                    <div *ngIf="f.dtgRegDtFromTime.errors.required">필수 입력 항목 입니다</div>
                <div class="invalid-tooltip" *ngIf="submitted && f.dtgRegDtFromTime.errors && checkRegDt">
                    <div *ngIf="!checkRegDt">중복 일정 입니다.</div>
                </div>
                <input type="time" class="form-control form-control-sm w-auto ml-2"
                   min="00:00:00"
                   max="23:59:59"
                   formControlName="dtgRegDtToTime"
                   (ngModelChange)="changeDtgRegTime($event, 'to')"
                   [ngClass]="{'is-invalid':submitted && (f.dtgRegDtToTime.errors || !checkRegDt)}">
                <div class="invalid-tooltip" *ngIf="submitted && f.dtgRegDtToTime.errors && f.dtgRegDtToTime.errors.required">
                    <div *ngIf="f.dtgRegDtToTime.errors.required">필수 입력 항목 입니다</div>
                </div>
                <div class="invalid-tooltip" *ngIf="submitted && !checkRegDt">
                    <div *ngIf="!checkRegDt">중복 일정 입니다.</div>
                </div>
                -->
            </div>
        </div>
        <div class="form-group row align-items-center">
            <label class="col-md-3 mb-0">
                노선
            </label>
            <div class="col-md-9 position-relative">
                <input type="text" class="form-control form-control-sm w-auto"
                       formControlName="drivePathNm">
            </div>
            <div class="col-md-9 offset-md-3 small mt-1">
                <small class="form-text text-muted">
                    노선번호 및 노선명을 작성해 주세요.
                </small>
            </div>
        </div>
        <div class="form-group row align-items-center">
            <label class="col-md-3 mb-0">
                기점
            </label>
            <div class="col-md-9 position-relative">
                <input type="text" class="form-control form-control-sm w-auto"
                       formControlName="drivePathFromNm">
            </div>
        </div>
        <div class="form-group row align-items-center">
            <label class="col-md-3 mb-0">
                종점
            </label>
            <div class="col-md-9 position-relative">
                <input type="text" class="form-control form-control-sm w-auto"
                       formControlName="drivePathToNm">
            </div>
        </div>
    </form>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-outline-success btn-sm"
            (click)="clickSave()"
            [hidden]="dtgActionType === DtgActionType.read">
        <i class="mdi mdi-content-save"></i>
        <span class="ml-1">
              저장
        </span>
    </button>
    <button type="button" class="btn btn-secondary btn-sm"
            (click)="clickCancel()">
        <i class="mdi mdi-close"></i>
        <span class="ml-1">
              취소
        </span>
    </button>
</div>
